import { createFileRoute } from '@tanstack/react-router'
import { patientsQueryOptions } from '~/features/dashboard/pages/patient-logs/api/queries'
import { PatientsPage } from '~/features/dashboard/pages/patient-logs/pages/patients'
import { getApiProgram } from '~/lib/utils'

export const Route = createFileRoute('/(dashboard)/dashboard/$program/patients/')({
  loader: ({ context, params }) => {
    context.queryClient.ensureQueryData(patientsQueryOptions({program: getApiProgram(params.program)}))
  },
  component: () => (
    <section role="region"
      aria-label="Patients"
      className="min-h-screen w-full mx-auto">
      <PatientsPage />
    </section>
  ),
  errorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="p-4">
      <h2 className="text-xl font-bold">Error Loading Patients Page</h2>
      <pre className="mt-4">{error.message}</pre>
    </div>
  ),
})

